<template>
  <div class="quad-viz-pure">
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>AD // BC & AB ∦ CD</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="280" viewBox="0 0 500 280">
          <g transform="translate(150, 60)">
            <!-- Parallel markers -->
            <path d="M 50,-10 L 60,0 L 50,10" fill="none" stroke="#ffd700" stroke-width="2" transform="translate(-10, 0)" />
            <path d="M 120,110 L 130,120 L 120,130" fill="none" stroke="#ffd700" stroke-width="2" transform="translate(-10, 0)" />

            <!-- Trapezoid Shape -->
            <path d="M 50 0 L 150 0 L 250 120 L 0 120 Z" fill="rgba(0, 210, 255, 0.15)" stroke="#00d2ff" stroke-width="3" />
            
            <!-- Vertices -->
            <circle cx="50" cy="0" r="4" fill="#fff" />
            <circle cx="150" cy="0" r="4" fill="#fff" />
            <circle cx="250" cy="120" r="4" fill="#fff" />
            <circle cx="0" cy="120" r="4" fill="#fff" />

            <line x1="50" y1="0" x2="250" y2="120" stroke="rgba(255,255,255,0.1)" stroke-dasharray="4" />
            <line x1="150" y1="0" x2="0" y2="120" stroke="rgba(255,255,255,0.1)" stroke-dasharray="4" />
          </g>
        </svg>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
          <p><strong>梯形性质：</strong>有一组对边平行，另一组对边不平行的四边形。平行的一组对边叫底，不平行的一组对边叫腰。梯形的高是两平行底之间的距离。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrapezoidViz',
  props: { knowledgePoint: { type: String, default: '' } }
}
</script>

<style scoped lang="scss">
.quad-viz-pure { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>